// adding music we just add this note class
export const customTextSelect = {
  attrs: {
    class: { default: 'playbackSelection' }
  },
  parseDOM: [{ tag: `span.playbackSelection` }],
  toDOM: function (mark) {
    return ['span', mark.attrs]
  }
}
